module.exports = __webpack_public_path__ + "img/heart.00ae121f.svg";